const QUICK = [
  { href: '#today', label: '今日重磅' },
  { href: '#weekly', label: '本周必看' },
  { href: '#monthly', label: '本月最劲爆' },
  { href: '#yearly', label: '年度盘点' },
  { href: '#feed', label: '全量吃瓜流' },
  { href: '#faq', label: '吃瓜百科' },
  { href: '#about', label: '关于我们' },
];

const TOPICS = ['综艺热闻', '影视热浪', '明星动态', '行业风向', '理性吃瓜'];

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-bard-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">必吃大瓜</span>
            </a>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              一间专注娱乐热闻的吃瓜编辑部，用今日重磅、本周必看、本月最劲爆与年度盘点，为你梳理一张清晰的瓜田地图。
            </p>
            <p className="mt-3 text-sm font-medium text-foreground-700">投稿 / 合作：</p>
            <a
              href="mailto:bichidagua@example.com"
              className="text-sm font-medium text-primary-600 underline-offset-4 hover:underline"
            >
              bichidagua@example.com
            </a>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">站内导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {QUICK.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="transition hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">热门栏目</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {TOPICS.map((t) => (
                <li key={t}>
                  <a href="#feed" className="transition hover:text-primary-600">
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">追更必吃大瓜</h3>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              把必吃大瓜加入浏览器收藏，每天点开都有新瓜吃；年度盘点专题正陆续放送，蹲住别走。
            </p>
            <div className="mt-4 flex items-center gap-2">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-douban-line', 'ri-rss-line'].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition hover:border-primary-500 hover:bg-primary-500 hover:text-background-50"
                  aria-label="订阅必吃大瓜"
                >
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 必吃大瓜 BICHIDAGUA · 保留所有权利</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-primary-500" /> 理性吃瓜 · 不信谣 · 不传谣 · 见官方
          </p>
        </div>
      </div>
    </footer>
  );
}